import { theme, Avatar, AvatarSize, IconDictionary, Tab, TabGroup } from '@ketch-com/deck'
import { useState, useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { Drawer } from 'components/ui-kit/drawer/Drawer'
import { useDataSentryContext } from 'pages/dataSentry/context/DataSentryContext'
import { Overview } from 'pages/dataSentry/data/networkDetails/Overview'
import { Found } from 'pages/dataSentry/data/networkDetails/Found'

function shortenURL(url: string) {
  if (!url) return url
  const parts = url.split('/')
  const protocol = parts[0]
  const domain = parts[2]
  const pathParts = parts.slice(3)

  if (pathParts.length <= 2) {
    return url
  }

  const first = pathParts[0]
  const last = pathParts[pathParts.length - 1]

  return `${protocol}//${domain}/${first}/.../${last}`
}

export const NetworkDetails: React.FC = () => {
  const [tab, setTab] = useState(0)
  const { networkDetails, setNetworkDetails, selectedProperty } = useDataSentryContext()

  const shortUrl = useMemo(() => {
    return shortenURL(networkDetails?.url || '')
  }, [networkDetails?.url])

  return (
    <Drawer
      open={Boolean(networkDetails)}
      onClose={() => setNetworkDetails?.(null)}
      PaperProps={{
        sx: {
          height: '90%',
          width: '100%',
          maxWidth: '1300px',
          margin: 'auto',
          padding: '32px',
          borderRadius: '37px 37px 0px 0px',
          overflow: 'hidden',
        },
      }}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h3" color={theme.palette.Text.Secondary}>
            Network Request
          </Typography>
          <Avatar
            borderColor={theme.palette.Black.o8}
            icon={IconDictionary.OSort}
            textColor={theme.palette.Black.o48}
            size={AvatarSize['medium']}
          />
          <Typography variant="h3">{shortUrl}</Typography>
          <Typography variant="h3" color={theme.palette.Text.Secondary}>
            on
          </Typography>
          <Avatar
            borderColor={theme.palette.Black.o8}
            icon={IconDictionary.OGlobe}
            textColor={theme.palette.Black.o48}
            size={AvatarSize['medium']}
            variant="square"
            sx={{ borderRadius: 1.5 }}
          />
          <Typography variant="h3">{selectedProperty?.name || selectedProperty?.code}</Typography>
        </Box>
        <TabGroup value={tab} onChange={(event: React.SyntheticEvent, newValue: number) => setTab(newValue)}>
          <Tab size={'medium'} label="Overview" />
          <Tab size={'medium'} label="Where It Was Found" />
        </TabGroup>

        {tab === 0 ? <Overview /> : null}
        {tab === 1 ? <Found /> : null}
      </Box>
    </Drawer>
  )
}
